import { createSelector } from 'reselect';
import { getIsSuperAdmin } from './scopes';
export const getIsContentAssistanceEnabled = state => {
  return state.contentAssistant.contentAssistanceEnabled;
};
export const getIsContentAssistanceRequestPending = state => {
  return Boolean(state.contentAssistant && state.contentAssistant.isRequesting);
};
export const getCanUseAIGeneratedContent = createSelector([getIsContentAssistanceEnabled], isContentAssistanceEnabled => {
  return Boolean(isContentAssistanceEnabled);
});
export const getCanUseContentAssistantOptInIntroModal = createSelector([getIsContentAssistanceEnabled, getIsSuperAdmin], (isContentAssistanceEnabled, isSuperAdmin) => {
  return isContentAssistanceEnabled || isSuperAdmin;
});